// export DsfPanel from "./panel";
// export DsfButton from "./button";
// export DsfMutiEllipsis from "./mutiEllipsis";
// export DsfFormControlBox from "./formControlBox";
// export DsfDropdownWrapper from "./dropdownWrapper";
// export DsfTreeSelect from "./treeSelect";
// export DsfAreaCascader from "./areaCascader";
// export DsfAreaCascaderPanel from "./areaCascaderPanel";
export const DsfButton = Vue.defineLazyComponent(() => require("./button"));
export const DsfFormControlBox = Vue.defineLazyComponent(() => require("./formControlBox"));
export const DsfPanel = Vue.defineLazyComponent(() => require("./panel"));
export const DsfDropdownWrapper = Vue.defineLazyComponent(() => require("./dropdownWrapper"));

export const DsfAreaCascader = Vue.defineLazyComponent(() => require("./areaCascader"));
export const DsfAreaCascaderPanel = Vue.defineLazyComponent(() => require("./areaCascaderPanel"));

export const DsfTreeSelect = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./treeSelect")
);
export const DsfMutiEllipsis = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./mutiEllipsis")
);
export const DsfCustomCheckbox = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./checkbox")
);
export const DsfPlatformPermissionSetting = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./permissionSetting")
);
export const DsfAngleSelect = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./utils/angleSelect/AngleSelect")
);
export const DsfColorSelect = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./utils/colorSelect/ColorSelect")
);
export const DsfLinearGradualSelect = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "platform_pc_output_common" */ "./utils/gradualSelect/LinearGradualSelect"
  )
);
export const DsfRadialGradualSelect = Vue.defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "platform_pc_output_common" */ "./utils/gradualSelect/RadialGradualSelect"
  )
);
export const DesMetaDataSelectItem = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_output_common" */ "./metaDataSelectItem")
);
